import { memo, useState } from 'react';
import css from './LegalDocumentLinks.module.scss';
import { useLocale, useLocalization } from '../../context/Localization/localization';
import { Locales, LocalizationType } from '../../context/Localization/localization.types';
import { LegalDocumentModal } from './LegalDocumentModal/LegalDocumentModal';
import { LegalDocumentType } from './LegalDocumentModal/LegalDocumentModal.types';
import { LegalDocumentLinksProps } from './LegalDocumentLinks.types';
import { GoMotoComponent } from '../../API/GoMoto.types';
import { isElectron } from '../../helpers/EnvironmentFlags/EnvironmentFlags';
import { getLegalDocumentUrl } from './getLegalDocumentUrl';

export const LegalDocumentLinks: GoMotoComponent<LegalDocumentLinksProps> = memo(({ className }: LegalDocumentLinksProps) => {
    const Localization: LocalizationType = useLocalization();
    const locale: Locales = useLocale();
    const [openType, setOpenType] = useState<LegalDocumentType | undefined>(undefined);

    /*
     * The kiosk strips KeyTrak's frame-blocking headers via Electron's webRequest hook,
     * so the embedded iframe modal works there. Browsers enforce those headers strictly
     * with no client-side bypass, so on mobile we open the page in a new tab instead.
     */
    const handleClick = (documentType: LegalDocumentType): void => {
        if (isElectron()) {
            setOpenType(documentType);
        }
        else {
            window.open(getLegalDocumentUrl(documentType, locale), '_blank', 'noopener,noreferrer');
        }
    };

    return (
        <div className={className ?? css.linksContainer}>
            {Localization.formatString(
                Localization.ViewOurTermsAndPrivacyPolicy,
                <span
                    key={'terms'}
                    className={css.link}
                    onClick={() => handleClick('terms')}
                    role={'button'}
                    tabIndex={0}
                >
                    {Localization.TermsOfUse}
                </span>,
                <span
                    key={'privacy'}
                    className={css.link}
                    onClick={() => handleClick('privacy')}
                    role={'button'}
                    tabIndex={0}
                >
                    {Localization.PrivacyPolicy}
                </span>,
            )}
            <LegalDocumentModal
                documentType={openType ?? 'terms'}
                open={openType !== undefined}
                onClose={() => setOpenType(undefined)}
            />
        </div>
    );
});
